module.exports = __webpack_public_path__ + "media/images/custom-video-prod-ba73433dba3857e33c10ba1ceefcc39d.png";